const activityTime = (request) => new Date(
  request.last_activity_at || request.updated_at || request.created_at || 0,
).getTime();

export const matchesCareRequestFilters = (request, filters = {}) => (
  (!filters.status || request.status === filters.status)
  && (!filters.player || request.player_id === filters.player)
  && (!filters.category || request.category === filters.category)
  && (!filters.priority || request.priority === filters.priority)
  && (!filters.scope || request.access_scope === filters.scope)
);

export const filterCareRequests = (requests, filters = {}) => requests
  .filter((request) => matchesCareRequestFilters(request, filters))
  .sort((left, right) => activityTime(right) - activityTime(left));

export const careRequestStatusCounts = (requests, filters = {}) => {
  const rows = requests.filter((request) => matchesCareRequestFilters(request, {
    ...filters, status: "",
  }));
  return rows.reduce((counts, request) => ({
    ...counts,
    all: counts.all + 1,
    [request.status]: (counts[request.status] || 0) + 1,
  }), { all: 0, new: 0, in_progress: 0, resolved: 0 });
};

export const reconcileCareRequestMutation = ({ requests, updated, selectedId, filters }) => {
  const rows = requests.map((request) => request.id === updated.id
    ? { ...request, ...updated, player: updated.player || request.player,
      access_scope: updated.access_scope || request.access_scope }
    : request);
  if (selectedId !== updated.id || matchesCareRequestFilters(updated, filters)) {
    return { requests: rows, selectedId };
  }
  return { requests: rows, selectedId: filterCareRequests(rows, filters)[0]?.id || "" };
};
